"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var IgnoreRematch_1 = require("../Actions/IgnoreRematch");
var StartRematch_1 = require("../Actions/StartRematch");
function useRematch() {
    var dispatch = react_redux_1.useDispatch();
    var rematchOffer = react_redux_1.useSelector(function (state) { return state.rematchOffer; });
    return {
        rematch: function () { return dispatch(StartRematch_1.startRematch()); },
        rematchOffer: rematchOffer,
        ignoreRematch: function () { return dispatch(IgnoreRematch_1.ignoreRematch()); },
        pending: rematchOffer && !rematchOffer.link
    };
}
exports.default = useRematch;
//# sourceMappingURL=useRematch.js.map